const BaseCategoryPage = require('base/hn-category-page');
const Server = require('helper/server');

class ZcyHNCategory extends BaseCategoryPage {
  constructor() {
    super({
      events: {
        'click .search-btn': 'handleSearch',
        'click .reset-btn': 'handleReset',
        'click .expand': 'handleExpand',
        'click .collapse': 'handleCollapse',
        'click #hn-item-classes li': 'itemChange',
        'click #hn-purchase-method li': 'purchaseMethodChange',
        'change select[name="procurementMethodCode"]' : 'purchaseMethodSelectChange',
        'change select[name="gpCatalogType"]' : 'gpCatalogTypeChange',
        'change select[name="announcement-types"]' : 'announcementTypesSelectChange',
      }
    });
    this.procurementMenuMode = [];
    this.initPage();
  }

  initPage() {
    this.initDate();
    this.initHeighSearch();
  }

  async initHeighSearch() {
    const payload = {
      queryWithCode: true,
      includeAllNode: false,
      includeSelf: false
    };
    const $root = $('.block__search form');

    // 区划 下拉
    const { data: districtList } = await Server.getAnnouncementDistrict(payload);
    const district = $root.find('select[name="districtCode"]');
    let options = '<option value="">全部</option>';
    $.map(districtList, item => {
      options += `<option value="${item.code}">${item.name}</option>`;
    });
    district.html(options);

    // 采购方式 树 下拉
    this.procurementMenuMode = await Server.queryProcurementMenuMode();
    const purchaseMethod = $('#hn-purchase-method');
    $.map(this.procurementMenuMode, item => {
      purchaseMethod.append(`<li data-value="${item.code}">${item.name}</li>`);
    });
    const procurement = $root.find('select[name="procurementMethodCode"]');
    let procurementOptions = '<option value="">全部</option>';
    $.map(this.procurementMenuMode, item => {
      procurementOptions += `<option value="${item.code}">${item.name}</option>`;
    });
    procurement.html(procurementOptions);

    // 品目分类 树 下拉
    this.itemClasses = await Server.queryItemClasses();
    const hnItemClasses = $('#hn-item-classes');
    $.map(this.itemClasses, item => {
      hnItemClasses.append(`<li data-value="${item.text}">${item.text}</li>`);
    });
    const itemClassesSelect = $root.find('select[name="gpCatalogType"]');
    let itemOptions = '<option value="">全部</option>';
    $.map(this.itemClasses, item => {
      itemOptions += `<option value="${item.text}">${item.text}</option>`;
    });
    itemClassesSelect.html(itemOptions);

    // 公告类型 下拉
    this.announcementTypes = await Server.queryAnnouncementTypes();
    const announcementTypesSelect = $root.find( 'select[name="announcement-types"]' );
    let annOptions = '<option value="" data-id="133010">全部</option>';
    $.map( this.announcementTypes, ( item ) => {
      annOptions += `<option value="${ item.code }" data-id="${item.id}">${ item.text }</option>`;
    } );
    announcementTypesSelect.html( annOptions );

  }

  initDate() {
    const $date = $('.date-range .date');
    $date.datetimepicker({
      format: 'yyyy-mm-dd',
      autoclose: true,
      maxView: 4,
      minView: 2,
      language: 'zh-CN'
    });
  }

  search(params) {
    const { showContent, code } = this.selectedTreeNode;
    const $form = this.$el.find('.block__search_wrap');
    const formItem = $form.find('.form_item');
    const query = this.query.params || {};

    let payload = {
      ...query,
      categoryCode: code,
      pageSize: this.pageSize,
      pageNo: this.pageNo,
    };


    $.map(formItem, item => {
      const key = $(item).attr('name');
      const value = $(item).val();
      if (value !== '' && value !== null) {
        if (key === 'districtCode') {
          if (payload[key]) {
            payload[key].push(value);
          } else {
            payload[key] = [value];
          }
        } else {
          payload[key] = value;
        }
      }
    });
    payload = {
      ...payload,
      ...params,
    }
    console.log('query', payload);
    Server.searchCategory(payload).then(res => {
      this.renderList(res);
    });
  }

  handleSearch() {
    this.search();
  }

  handleReset() {
    const $form = this.$el.find('.block__search_wrap');
    $form[0].reset();
    this.search();
    this.purchaseMethodSelectChangeAction("");
    this.gpCatalogTypeChangeAction("");
    $(".list__nav-content").jstree("close_all");
    $(".list__nav-content").jstree("deselect_all", true);
    $('.list__nav-content').jstree('select_node', "133010");
  }

  handleExpand() {
    $('.block__search').animate(
      {
        height: '196px'
      },
      100,
      '',
      () => {
        // $( '.block__search' ).css( 'overflow', 'unset' );
        $('.block__search').removeClass('overHiden');
      }
    );
    this.$el.find('.expand, .collapse').toggle();
  }

  handleCollapse() {
    $('.block__search').addClass('overHiden');
    $('.block__search').animate(
      {
        height: '60px',
        overflow: 'hidden'
      },
      100
    );
    this.$el.find('.expand, .collapse').toggle();
  }
  itemChange( e ) {
    const $el = $( e.currentTarget );
    $el
      .addClass( 'active' )
      .siblings( 'li' )
      .removeClass( 'active' );
    const gpCatalogType = $el.attr('data-value');
    $('.block__search form').find('select[name="gpCatalogType"]').val(gpCatalogType);
    this.search({gpCatalogType});
  }
  purchaseMethodChange( e ) {
    const $el = $( e.currentTarget );
    $el
      .addClass( 'active' )
      .siblings( 'li' )
      .removeClass( 'active' );
    const procurementMethodCode = $el.attr('data-value');
    $('.block__search form').find('select[name="procurementMethodCode"]').val(procurementMethodCode);
    this.search({procurementMethodCode});
  }

  purchaseMethodSelectChange (e) {
    const code = e.target.value;
    this.purchaseMethodSelectChangeAction(code);
  }
  purchaseMethodSelectChangeAction(code) {
    const li= $('#hn-purchase-method li');
    li.removeClass( 'active' );
    Array.from(li).map(x => {
      if ($(x).attr('data-value') === code) {
        $(x).addClass('active');
      }
    });
  }
  gpCatalogTypeChange (e) {
    const code = e.target.value;
    this.gpCatalogTypeChangeAction(code);
  }
  gpCatalogTypeChangeAction (code){
    const li= $('#hn-item-classes li');
    li.removeClass( 'active' );
    Array.from(li).map(x => {
      if ($(x).attr('data-value') === code) {
        $(x).addClass('active');
      }
    });
  }
  announcementTypesSelectChange (e) {
    const value = e.target.value;
    let id= '';
    this.announcementTypes.map(x => {
      if ( value === x.code){
        id= x.id
      }
    });
    $(".list__nav-content").jstree("close_all");
    $(".list__nav-content").jstree("deselect_all", true);
    $('.list__nav-content').jstree('select_node', id);
  }
  selectTreeNode (event, data) {
    console.log(data.instance.get_node(data.instance.get_selected()[0]), '---');
    const original = data.instance.get_node(data.instance.get_selected()[0]).original;
    const { path, code } = original;
    const pCode = path.split(".") && path.split(".")[2];
    $('.block__search form').find('select[name="announcement-types"]').val(pCode);
    this.search({categoryCode: code});
  }
}

module.exports = ZcyHNCategory;
